module.exports = "https://r.zoocdn.com/_next/static/images/portability-42776f6a55eb160b6a5e1fbf6810a2df.svg";